module.exports = __webpack_public_path__ + "img/icon_search.06d4ba4b.svg";